/* eslint-disable @typescript-eslint/no-explicit-any */
import {AxiosResponse} from "axios";

/**
 * Класс ошибки для API вызовов
 *
 * @class
 * @augments Error
 * @param {Object} data - Данные ошибки из запроса
 * @returns {void}
 */
class ApiError extends Error {
  private data?: any;

  private response?: AxiosResponse;

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  constructor(message?: string, data?: any, response?: AxiosResponse) {
    super(message);
    this.name = "ApiError";
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    this.data = data;
    this.response = response;
    Object.setPrototypeOf(this, new.target.prototype);
  }
}

export default ApiError;
